import { render, staticRenderFns } from "./case6.vue?vue&type=template&id=613728e9&scoped=true&"
import script from "./case6.vue?vue&type=script&lang=js&"
export * from "./case6.vue?vue&type=script&lang=js&"
import style0 from "./case6.vue?vue&type=style&index=0&id=613728e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613728e9",
  null
  
)

export default component.exports